import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from "@madmedical/routing";
import { invariant } from "@madmedical/utils";
import { MeasurementType, PatientMeasurementDetails } from "@madmedical/ui";
import { useMe, usePatientId } from "@madmedical/user";
import { useState } from "react";
import { isManualAllowed } from "@madmedical/medical";
import { EditThresholdModal } from "@madmedical/threshold";
import AddCommentButtonForm from "../../comment/components/AddCommentButtonForm";
import MeasurementProviders from "./MeasurementProviders";
import ManualMeasurementModalForm from "./ManualMeasurementModalForm";
var ModalState;
(function (ModalState) {
    ModalState[ModalState["Closed"] = 0] = "Closed";
    ModalState[ModalState["Manual"] = 1] = "Manual";
    ModalState[ModalState["Threshold"] = 2] = "Threshold";
})(ModalState || (ModalState = {}));
const Measurements = () => {
    const { isSelfOrRepresented } = usePatientId();
    const { roles: { isDoctor }, } = useMe();
    const { metricType } = useParams();
    invariant(metricType);
    const [modal, setModal] = useState(ModalState.Closed);
    const handleEditThresholdPress = () => {
        setModal(ModalState.Threshold);
    };
    const handleManualPress = () => {
        setModal(ModalState.Manual);
    };
    const handleModalClose = () => {
        setModal(ModalState.Closed);
    };
    const canAddManual = isManualAllowed(metricType);
    return (_jsx(MeasurementProviders, Object.assign({ metricType: metricType }, { children: isSelfOrRepresented ? (_jsxs(_Fragment, { children: [_jsx(MeasurementType, { metricType: metricType, addCommentButton: _jsx(AddCommentButtonForm, {}), onManualPress: canAddManual ? handleManualPress : null }), canAddManual && (_jsx(ManualMeasurementModalForm, { metricType: metricType, open: modal === ModalState.Manual, onClose: handleModalClose }))] })) : (_jsxs(_Fragment, { children: [_jsx(PatientMeasurementDetails, { metricType: metricType, addCommentButton: _jsx(AddCommentButtonForm, {}), canWriteEvaluation: isDoctor, onEditThresholdPress: handleEditThresholdPress }), _jsx(EditThresholdModal, { metricType: metricType, open: modal === ModalState.Threshold, onClose: handleModalClose })] })) })));
};
export default Measurements;
